import { useEffect } from 'react';

/**
 * Member photos are view-only (founder, Nov 2026): no right-click "Save
 * image", no dragging the photo out, no long-press save menu on phones.
 *
 * One listener for the whole app instead of a prop on every <img>: any image
 * served from member photo storage or a Google sign-in avatar is covered,
 * wherever it renders (Matches, profiles, interests, messages, lightbox).
 * The matching CSS (no iOS long-press callout, no drag) lives in index.css.
 *
 * Honest limit: this stops saving, not screenshots — no website can block
 * those, so member-facing copy never promises it.
 */
const MEMBER_PHOTO_SRC = [
  /\.amazonaws\.com\/(thumbnails\/)?photos\//,
  /googleusercontent\.com\//,
];

export const isMemberPhoto = (el) =>
  el?.tagName === 'IMG' && MEMBER_PHOTO_SRC.some((re) => re.test(el.currentSrc || el.src || ''));

const MemberPhotoGuard = () => {
  useEffect(() => {
    const block = (e) => { if (isMemberPhoto(e.target)) e.preventDefault(); };
    document.addEventListener('contextmenu', block);
    document.addEventListener('dragstart', block);
    return () => {
      document.removeEventListener('contextmenu', block);
      document.removeEventListener('dragstart', block);
    };
  }, []);
  return null;
};

export default MemberPhotoGuard;
